import { IconPackageExport, type IconProps } from "@tabler/icons-react";
import type { ComponentType } from "react";
import { useTranslation } from "react-i18next";
import type { InternalTourTask } from "../types";
import { isBulkTask } from "../guards";

export function useTourTaskItem(item: InternalTourTask) {
  const { t } = useTranslation();

  const taskTypeMap: Record<
    InternalTourTask["type"],
    {
      text: string;
      Icon?: ComponentType<IconProps>;
    }
  > = {
    "gatherTask-pickup": {
      text: t("gatherPickup.collect.single"),
      Icon: undefined,
    },
    "order-delivery": {
      text: t("tourStopCard.deliver"),
      Icon: IconPackageExport,
    },
    "order-pickup": {
      text: t("orderPickup.collect.single"),
      Icon: undefined,
    },
    "gatherTask-dropOff": {
      text: t("gatherDropoff.dropOff.single"),
      Icon: IconPackageExport,
    },
  };

  return taskTypeMap[item.type];
}
